import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import dayjs, { Dayjs } from 'dayjs';
import { Observable } from 'rxjs';
import {
  AveragePickTimeDashboardConfiguration,
  UnitSourceType,
} from './average-pick-time-dashboard-configuration';
import { ResultFieldFilter } from '../job-result-analytics-dashboard/job-result-analytics-dashboard-configuration';
import { JobDashboardRange } from '../job-dashboard/job-dashboard-configuration';
import { environment } from '../../../../../environments/environment';
import {
  getFromForRange,
  getToForRange,
} from '../job-dashboard/job-dashboard-range.utils';

export interface JobAveragePickTimeResponse {
  totalDurationSeconds: number;
  totalUnits: number;
  averageSecondsPerUnit: number | null;
  jobCount: number;
  warnings: string[];
}

interface JobAveragePickTimeRequest {
  from: Dayjs;
  to: Dayjs;
  statuses?: string[];
  dataConnectionIds?: string[];
  filters?: ResultFieldFilter[];
  unitSource: {
    type: UnitSourceType;
    fieldKey?: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class AveragePickTimeDashboardService {
  protected http = inject(HttpClient);

  getData(
    config: AveragePickTimeDashboardConfiguration,
    from: Dayjs,
    to: Dayjs,
  ): Observable<JobAveragePickTimeResponse> {
    const requestBody: JobAveragePickTimeRequest = {
      from,
      to,
      statuses: config.statuses,
      dataConnectionIds: config.dataConnectionIds,
      filters: config.filters,
      unitSource: {
        type: config.unitSourceType,
        fieldKey:
          config.unitSourceType === UnitSourceType.FIELD_SUM
            ? config.unitFieldKey?.trim()
            : undefined,
      },
    };

    return this.http.post<JobAveragePickTimeResponse>(
      `${environment.apiUrls.workflow}/api/v1/dashboard/jobs/results/average-pick-time`,
      requestBody,
    );
  }

  getFromForRange(range: JobDashboardRange, referenceTime = dayjs()): Dayjs {
    return getFromForRange(range, referenceTime);
  }

  getToForRange(range: JobDashboardRange, referenceTime = dayjs()): Dayjs {
    return getToForRange(range, referenceTime);
  }
}
